module.exports = "../../app/cells/pages/questions/questions_filter_banner_cell.rb";